import { forwardRef } from 'react';

export const MailOutlineFilled = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 88 88" fill="none" {...props}>
        <path
          d="M73.33 14.67H14.67c-4.04 0-7.3 3.3-7.3 7.33l-.04 44c0 4.03 3.3 7.33 7.34 7.33h58.66c4.04 0 7.34-3.3 7.34-7.33V22c0-4.03-3.3-7.33-7.34-7.33Zm0 51.33H14.67V29.33L44 47.67l29.33-18.34V66ZM44 40.33 14.67 22h58.66L44 40.33Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
